/**
 * Utility functions for authentication-related operations
 */

/**
 * Redirects to signin page with the current page as callback URL
 * @param router - Next.js router instance
 * @param customCallbackUrl - Optional custom callback URL, defaults to current page
 */
export const redirectToSignin = (
  router: { push: (url: string) => void },
  customCallbackUrl?: string
) => {
  const callbackUrl =
    customCallbackUrl ||
    (typeof window !== "undefined"
      ? window.location.pathname + window.location.search
      : "/")
  const encodedCallbackUrl = encodeURIComponent(callbackUrl)
  router.push(`/auth/signin?callbackUrl=${encodedCallbackUrl}`)
}

/**
 * Gets the callback URL from search params or falls back to current page
 * @param searchParams - URLSearchParams instance
 * @returns The callback URL to redirect to after signin
 */
export const getCallbackUrl = (
  searchParams?: URLSearchParams | null
): string => {
  const callbackUrl = searchParams?.get("callbackUrl")
  if (callbackUrl) {
    return callbackUrl
  }

  // Fallback to current page or referrer or home page
  if (typeof window !== "undefined") {
    // If we're not on the signin page, use current page as callback
    if (!window.location.pathname.includes("/auth/signin")) {
      return window.location.pathname + window.location.search
    }
    // If we're on signin page, use referrer or home
    return document.referrer || "/"
  }

  return "/"
}
